export enum AuthLevelRole {
  GLOBAL_ADMIN = "globalAdmin",
  COUNTRY_KEY_ACCOUNT_MANAGER = "countryKeyAccountManager",
  USER = "user",
  BLOCKED = "blocked",
}
